import { AiseaApiFactory } from "@/api/aisea/apiFactory";
import { db } from "@/firebase/firebaseConfig.js";
const portSelectApi = AiseaApiFactory.get("portMasterPortSelect");
const portMasterVesselMasterApi = AiseaApiFactory.get("portMasterVesselMaster");
const portMasterBerthMasterApi = AiseaApiFactory.get("portMasterBerthMaster");
const portMasterEnterpriseAgencyMasterApi = AiseaApiFactory.get("portMasterEnterpriseAgencyMaster");
const portMasterAgencyMasterApi = AiseaApiFactory.get("portMasterAgencyMaster");
const portMasterPilotMasterApi = AiseaApiFactory.get("portMasterPilotMaster");
const portMasterTeamLeaderMasterApi = AiseaApiFactory.get("portMasterTeamLeaderMaster");
const portMasterTugBoatMasterApi = AiseaApiFactory.get("portMasterTugBoatMaster");
const portMasterVehicleMasterApi = AiseaApiFactory.get("portMasterVehicleMaster");
const portMasterRopePickingBoatMasterApi = AiseaApiFactory.get("portMasterRopePickingBoatMaster");
const portMasterTagMasterApi = AiseaApiFactory.get("portMasterTagMaster");
const portMasterWharfApi = AiseaApiFactory.get("portMasterPortWharf");
const portMasterColorApi = AiseaApiFactory.get("portMasterPortColor");
const portMasterTasksApi = AiseaApiFactory.get("portMasterTasks");
const portMasterDailyReportsApi = AiseaApiFactory.get("portMasterDailyReports");

export default {
  async fetchPorts({ commit }, payload) {
    let res = await portSelectApi.fetch(payload);
    let portsArray = res.data.ports.map((element) => {
      return {
        id: element.id,
        name: element.port.name,
        name_en: element.port.name_en,
        hash: element.hash
      }
    })
    commit("SET_PORT_OPTIONS", portsArray);
    return portsArray;
  },

  async selectPort({ commit }, payload) {
    commit("SET_SELECTED_PORT", payload);
  },

  async setStoredMasterSearchCondition({ commit }, payload) {
    commit("SET_STORED_MASTER_SEARCH_CONDITION", payload);
  },

  // 水先案内人API
  async fetchPilots(_, payload) {
    let res = await portMasterPilotMasterApi.fetch(payload);
    return res.data;
  },
  async deletePilot(_, payload) {
    let res = await portMasterPilotMasterApi.delete(payload.portId, payload.id);
    return res.data;
  },
  async insertPilot(_, payload) {
    await portMasterPilotMasterApi.add(payload.portId, payload.body).then(res => {
      if ( !res || !res.status ) {
        throw res
      } else {
        return res.data
      }
    })
  },
  async updatePilot(_, payload) {
    await portMasterPilotMasterApi.update(payload.portId, payload.id, payload.body).then(res => {
      if ( !res || !res.status ) {
        throw res
      } else {
        return res.data
      }
    })
  },
  async updatePilotOrders(_, payload) {
    let res = await portMasterPilotMasterApi.updateOrders(payload.portId, payload.body);
    return res.data;
  },

  // 班長API
  async fetchTeamLeaders(_, payload) {
    let res = await portMasterTeamLeaderMasterApi.fetch(payload);
    return res.data;
  },
  async deleteTeamLeader(_, payload) {
    let res = await portMasterTeamLeaderMasterApi.delete(payload.portId, payload.id);
    return res.data;
  },
  async insertTeamLeader(_, payload) {
    await portMasterTeamLeaderMasterApi.add(payload.portId, payload.body).then(res => {
      if ( !res || !res.status ) {
        throw res
      } else {
        return res.data
      }
    })
  },
  async updateTeamLeader(_, payload) {
    await portMasterTeamLeaderMasterApi.update(payload.portId, payload.id, payload.body).then(res => {
      if ( !res || !res.status ) {
        throw res
      } else {
        return res.data
      }
    })
  },
  async updateTeamLeaderOrders(_, payload) {
    let res = await portMasterTeamLeaderMasterApi.updateOrders(payload.portId, payload.body);
    return res.data;
  },

  // タグボートAPI
  async fetchTugBoats(_, payload) {
    let res = await portMasterTugBoatMasterApi.fetch(payload);
    return res.data;
  },
  async deleteTugBoat(_, payload) {
    let res = await portMasterTugBoatMasterApi.delete(payload.portId, payload.id);
    return res.data;
  },
  async insertTugBoat(_, payload) {
    await portMasterTugBoatMasterApi.add(payload.portId, payload.body).then(res => {
      if ( !res || !res.status ) {
        throw res
      } else {
        return res.data
      }
    })
  },
  async updateTugBoat(_, payload) {
    await portMasterTugBoatMasterApi.update(payload.portId, payload.id, payload.body).then(res => {
      if ( !res || !res.status ) {
        throw res
      } else {
        return res.data
      }
    })
  },
  async updateTugBoatOrders(_, payload) {
    let res = await portMasterTugBoatMasterApi.updateOrders(payload.portId, payload.body);
    return res.data;
  },

  // 車両API
  async fetchVehicles(_, payload) {
    let res = await portMasterVehicleMasterApi.fetch(payload);
    return res.data;
  },
  async deleteVehicle(_, payload) {
    let res = await portMasterVehicleMasterApi.delete(payload.portId, payload.id);
    return res.data;
  },
  async insertVehicle(_, payload) {
    await portMasterVehicleMasterApi.add(payload.portId, payload.body).then(res => {
      if ( !res || !res.status ) {
        throw res
      } else {
        return res.data
      }
    })
  },
  async updateVehicle(_, payload) {
    await portMasterVehicleMasterApi.update(payload.portId, payload.id, payload.body).then(res => {
      if ( !res || !res.status ) {
        throw res
      } else {
        return res.data
      }
    })
  },
  async updateVehicleOrders(_, payload) {
    let res = await portMasterVehicleMasterApi.updateOrders(payload.portId, payload.body);
    return res.data;
  },

  // 綱取りボートAPI
  async fetchRopePickingBoats(_, payload) {
    let res = await portMasterRopePickingBoatMasterApi.fetch(payload);
    return res.data;
  },
  async deleteRopePickingBoat(_, payload) {
    let res = await portMasterRopePickingBoatMasterApi.delete(payload.portId, payload.id);
    return res.data;
  },
  async insertRopePickingBoat(_, payload) {
    await portMasterRopePickingBoatMasterApi.add(payload.portId, payload.body).then(res => {
      if ( !res || !res.status ) {
        throw res
      } else {
        return res.data
      }
    })
  },
  async updateRopePickingBoat(_, payload) {
    await portMasterRopePickingBoatMasterApi.update(payload.portId, payload.id, payload.body).then(res => {
      if ( !res || !res.status ) {
        throw res
      } else {
        return res.data
      }
    })
  },
  async updateRopePickingBoatOrders(_, payload) {
    let res = await portMasterRopePickingBoatMasterApi.updateOrders(payload.portId, payload.body);
    return res.data;
  },

  // タグAPI
  async fetchTags(_, payload) {
    let res = await portMasterTagMasterApi.fetch(payload);
    return res.data;
  },
  async deleteTag(_, payload) {
    let res = await portMasterTagMasterApi.delete(payload.portId, payload.id);
    return res.data;
  },
  async insertTag(_, payload) {
    await portMasterTagMasterApi.add(payload.portId, payload.body).then(res => {
      if ( !res || !res.status ) {
        throw res
      } else {
        return res.data
      }
    })
  },
  async updateTag(_, payload) {
    await portMasterTagMasterApi.update(payload.portId, payload.id, payload.body).then(res => {
      if ( !res || !res.status ) {
        throw res
      } else {
        return res.data
      }
    })
  },
  async updateTagOrders(_, payload) {
    let res = await portMasterTagMasterApi.updateOrders(payload.portId, payload.body);
    return res.data;
  },

  // 船舶API
  async fetchVessels(_, payload) {
    let res = await portMasterVesselMasterApi.fetch(payload.portId);
    return res.data;
  },
  async deleteVessel(_, payload) {
    let res = await portMasterVesselMasterApi.delete(payload.portId, payload.id);
    return res.data;
  },
  async insertVessel(_, payload) {
    await portMasterVesselMasterApi.add(payload.portId, payload.body).then(res => {
      if ( !res || !res.status ) {
        throw res
      } else {
        return res.data
      }
    })
  },
  async fetchVesselDetail(_, payload) {
    let res = await portMasterVesselMasterApi.fetchDetail(payload.portId, payload.id);
    return res.data;
  },
  async updateVessel(_, payload) {
    await portMasterVesselMasterApi.update(payload.portId, payload.id, payload.body).then(res => {
      if ( !res || !res.status ) {
        throw res
      } else {
        return res.data
      }
    })
  },
  async searchVessels(_, payload) {
    let res = await portMasterVesselMasterApi.search(payload.portId, payload.query);
    return res.data;
  },

  // バースAPI
  async fetchBerths(_, payload) {
    let res = await portMasterBerthMasterApi.fetch(payload.portId);
    return res.data;
  },
  async deleteBerth(_, payload) {
    let res = await portMasterBerthMasterApi.delete(payload.portId, payload.id);
    return res.data;
  },
  async insertBerth(_, payload) {
    await portMasterBerthMasterApi.add(payload.portId, payload.body).then(res => {
      if ( !res || !res.status ) {
        throw res
      } else {
        return res.data
      }
    })
  },
  async fetchBerthDetail(_, payload) {
    let res = await portMasterBerthMasterApi.fetchDetail(payload.portId, payload.id);
    return res.data;
  },
  async updateBerth(_, payload) {
    await portMasterBerthMasterApi.update(payload.portId, payload.id, payload.body).then(res => {
      if ( !res || !res.status ) {
        throw res
      } else {
        return res.data
      }
    })
  },
  async searchBerths(_, payload) {
    let res = await portMasterBerthMasterApi.search(payload.portId, payload.query);
    return res.data;
  },
  async updateBerthOrders(_, payload) {
    let res = await portMasterBerthMasterApi.updateOrders(payload.portId, payload.body);
    return res.data;
  },

  // 代理店（法人）API
  async fetchEnterpriseAgencies() {
    let res = await portMasterEnterpriseAgencyMasterApi.fetch();
    return res.data;
  },
  async deleteEnterpriseAgency(_, payload) {
    let res = await portMasterEnterpriseAgencyMasterApi.delete(payload.id);
    return res.data;
  },
  async insertEnterpriseAgency(_, payload) {
    await portMasterEnterpriseAgencyMasterApi.add(payload.body).then(res => {
      if ( !res || !res.status ) {
        throw res
      } else {
        return res.data
      }
    })
  },
  async fetchEnterpriseAgencyDetail(_, payload) {
    let res = await portMasterEnterpriseAgencyMasterApi.fetchDetail(payload.id);
    return res.data;
  },
  async updateEnterpriseAgency(_, payload) {
    await portMasterEnterpriseAgencyMasterApi.update(payload.id, payload.body).then(res => {
      if ( !res || !res.status ) {
        throw res
      } else {
        return res.data
      }
    })
  },
  async searchEnterpriseAgencies(_, payload) {
    let res = await portMasterEnterpriseAgencyMasterApi.search(payload.query);
    return res.data;
  },

  // 代理店API
  async fetchAgencies(_, payload) {
    let res = await portMasterAgencyMasterApi.fetch(payload);
    return res.data;
  },
  async deleteAgency(_, payload) {
    let res = await portMasterAgencyMasterApi.delete(payload.portId, payload.id);
    return res.data;
  },
  async insertAgency(_, payload) {
    let res = await portMasterAgencyMasterApi.add(payload.portId, payload.body);
    return res.data;
  },
  async fetchAgencyDetail(_, payload) {
    let res = await portMasterAgencyMasterApi.fetchDetail(payload.portId, payload.id);
    return res.data;
  },
  async updateAgency(_, payload) {
    let res = await portMasterAgencyMasterApi.update(payload.portId, payload.id, payload.body);
    return res.data;
  },
  async updateAgencyOrders(_, payload) {
    let res = await portMasterAgencyMasterApi.updateOrders(payload.portId, payload.body);
    return res.data;
  },

  async fetchColors({ commit }, payload) {
    let res = await portMasterColorApi.fetch(payload);
    commit("SET_COLORS", res.data);
    return res.data;
  },

  async fetchWharfs(_, payload) {
    let res = await portMasterWharfApi.fetch(payload);
    return res.data;
  },
  async fetchRanks({ commit, state }, _) {
    await db
      .collection("pm_settings")
      .doc(state.selectedPort.hash)
      .collection("constants")
      .doc("rank")
      .get().then(
        doc => {
          if ( doc.data() ) {
            let ranks = doc.data()
            ranks = Object.keys(ranks).map((element) => {
              return {
                id: element,
                name: ranks[element],
              }
            })
            commit("SET_RANK_OPTIONS", ranks)
          }
        }
      )
  },
  async fetchDisplaySettings({ commit, state }, _) {
    let displaySettings = []
    await db
      .collection("pm_settings")
      .doc(state.selectedPort.hash)
      .collection("monitors")
      .get().then(function(querySnapshot) {
        querySnapshot.forEach(function(doc) {
          let data = doc.data()
          displaySettings.push(
            {
              number: doc.id,
              limit: data.limit,
              offset: data.offset,
            }
          )
        })
      })
    commit("SET_DISPLAY_SETTINGS", displaySettings)
  },

  async exportTasks(_, payload) {
    let res = await portMasterTasksApi.export(payload.portId, payload.date);
    return res;
  },

  async downloadTasks(_, payload) {
    let res = await portMasterTasksApi.download(payload.portId, payload.date);
    return res;
  },

  async exportDailyReports(_, payload) {
    let res = await portMasterDailyReportsApi.export(payload.portId, payload.date);
    return res;
  },
}
